import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import type { Database } from '@/lib/database.types';

type CompanyRow = Database['public']['Tables']['companies']['Row'];

export function ProfilePage() {
  const { profile } = useAuth();
  const [company, setCompany] = useState<Partial<CompanyRow> | null>(null);
  const [editing, setEditing] = useState(false);

  if (!profile) return <div className="max-w-3xl mx-auto py-12"><p className="text-text-secondary">Nicht eingeloggt.</p></div>;

  return (
    <div className="max-w-3xl mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Profil</h1>

      <section className="mb-8">
        <h2 className="text-lg font-serif mb-3">Kontoinformationen</h2>
        <table>
          <tbody>
            <tr><th className="w-48">Status</th><td>{profile.status}</td></tr>
            <tr><th>Rolle</th><td>{profile.role}</td></tr>
            <tr><th>Erstellt am</th><td>{new Date(profile.created_at).toLocaleDateString('de-DE')}</td></tr>
          </tbody>
        </table>
      </section>

      {company && (
        <section className="mb-8">
          <h2 className="text-lg font-serif mb-3">Unternehmensdaten</h2>
          <table>
            <tbody>
              <tr><th className="w-48">Unternehmen</th><td>{company.name}</td></tr>
              <tr><th>Rechtsform</th><td>{company.rechtsform}</td></tr>
              <tr><th>Sitzland</th><td>{company.sitzland}</td></tr>
              <tr><th>Handelsregister</th><td>{company.handelsregister}</td></tr>
              <tr><th>USt-IdNr.</th><td>{company.ust_id || '—'}</td></tr>
              <tr><th>Ansprechpartner</th><td>{company.ansprechpartner_vorname} {company.ansprechpartner_nachname}</td></tr>
              <tr><th>Position</th><td>{company.position}</td></tr>
              <tr><th>Telefon</th><td>{company.telefon}</td></tr>
            </tbody>
          </table>
        </section>
      )}

      <a href="/profil/dokumente" className="btn-primary">KYC-Dokumente verwalten</a>
    </div>
  );
}
